import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { validaCPF, validaEmail } from "../components/generalFunctions"
import TextInput from "../components/TextInput";
import toast from 'react-hot-toast'
import api from "../components/api";

const ModalResgataSenha = (props: any) => {


    const [cpf, setCpf] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [modo, setModo] = useState<string>('resgataSenha')


    useEffect(() => {

        setCpf('')
        setEmail('')
        setModo('resgataSenha')
        
    }, [props.now])

    const resgataSenha = async () => {

        if (!validaCPF(cpf.replaceAll('-', '').replaceAll('.', ''))) {
            
            toast.error('CPF inválido!')
            return false

        }

        if (!validaEmail(email)) {

            toast.error('E-mail inválido!')
            return false
        }

        var dataPost = {

            cpf: cpf.replaceAll('-', '').replaceAll('.', ''),
            email: email,

        }

        toast.loading('Aguarde...')

        await api.post('resgataSenha', dataPost).then((result) => {

            console.log(result.data)
            
            if (result.data.status === 'ok') {

                setModo('senhaResgatada')
                toast.dismiss()
                toast.success('E-mail enviado com sucesso!')
                
                return true
                
            } else {
                toast.error(result.data.erro)
                return false
            }

        }).catch((error) => {
            
            console.log(error.response)
            toast.error('Erro ao resgatar senha!')
            return false

        })

    }

    return (

        <div>

            <Modal
                size="lg"
                show={props.show}
                onHide={() => props.setShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">

                    
                        Resgatar senha



                </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row g-3">    

                        <div className="col-md-12" style={{ display: modo == 'resgataSenha' ? 'table-row' : 'none'}}>


                            <p>
                                <center>Informe seu CPF e e-mail cadastrados que enviaremos um link para redefinição de sua senha:</center>
                            </p>

                        </div>

                        <div className="col-md-12" style={{ display: modo == 'senhaResgatada' ? 'table-row' : 'none'}}>


                            <p>
                                <center>Um e-mail contendo um link para redefinição de sua senha foi enviada para seu email.</center>
                            </p>

                        </div>

                        <div className="col-md-3" style={{ display: modo == 'resgataSenha' ? 'table-row' : 'none'}}>
                            <label className="form-label">CPF *</label>
                            <TextInput placeholder="000.000.0000-00" maskType="cpf" value={cpf} className="form-control"
                                onChange={event => setCpf(event.target.value)} 
                                
                                />
                        </div>

                        <div className="col-md-9" style={{ display: modo == 'resgataSenha' ? 'table-row' : 'none'}}>
                            <label className="form-label">E-mail *</label>
                            <input type="email" className="form-control" value={email} placeholder='email@cadastrado.com' onChange={event => setEmail(event.target.value)} />
                        </div>


                        <div className="col-12" style={{ textAlign: 'right'}}>
                                                        
                            <button type="button" className="btn btn-dark" onClick={() => props.setShow(false)}>Fechar</button>&nbsp;
                            <button type="button" className="btn btn-success" onClick={resgataSenha}  style={{ display: modo == 'resgataSenha' ? 'table-row' : 'none'}}>Resgatar senha</button>
                            
                        </div>

                    </div>

                </Modal.Body>

            </Modal>


        </div>

    )

}

export default ModalResgataSenha